/**
 * `tags` → **Settings** (spec M1-B5 §6.2, card P-123).
 *
 * The tag vocabulary is **account-level**, not column-level (`[09§A.7 tags]`, spec M2 tier-2 §5.2),
 * which is why `tagsSettingsSchema` is `{hide_footer}` and why the captured `Settings` submenu
 * (`editors/tags/dialog-settings-0.json`) has no *Customize Tags column*: there is nothing about
 * a tags **column** to configure. Editing the vocabulary itself belongs to the account screen.
 */
import type { TagsSettings } from '@elizmonday/shared';
import { HideSummaryField, SettingsForm, useSettingsDraft } from '../settings-kit';
import type { ColumnSettingsProps } from '../types';

export function TagsSettingsDialog({ settings, onCommit, onCancel }: ColumnSettingsProps<TagsSettings>) {
  const [draft, patch] = useSettingsDraft<TagsSettings>(settings);
  return (
    <SettingsForm
      title="Tags column settings"
      testId="tags-settings"
      onSave={() => onCommit(draft)}
      onCancel={onCancel}
    >
      <HideSummaryField
        divider={false}
        testId="tags-hide-footer"
        checked={draft.hide_footer ?? false}
        onChange={(next) => patch({ hide_footer: next })}
      />
    </SettingsForm>
  );
}
